export default class WapiDvariant {
  constructor() {
    this.id = '';
    this.domain = '';
    this.predicts = [];
    this.prioritet = '';
    this.is_interpolate_preset = false;
    this.is_interpolate_point = false;
    this.parameters = [];
  }

}
